export default {
  "content": "<circle cx=\"40\" cy=\"40\" r=\"40\" fill=\"#000\" fill-opacity=\".03\"/><path d=\"M45.5 28.334v3.333h-6.666v6.666H35.5V35h-10v16.667h30V28.333h-10zm-13.333 20h-3.333v-10h3.333v10zm6.667 0H35.5v-6.667h3.334v6.666zm6.666 0h-3.333V35H45.5v13.334zm6.667 0h-3.333V31.666h3.333v16.666z\" fill=\"#000\" fill-opacity=\".3\"/>",
  "attrs": {
    "width": "80",
    "height": "80",
    "viewBox": "0 0 80 80",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};